export default "__VITE_ASSET__SCDSYbXO__"